import {Modal, ModalBody, ModalContent, ModalFooter, ModalHeader} from "@heroui/react";
import React from 'react';
import PButton from "../components/PButton.tsx";
import {useGlobalModal} from "../core/GlobalModal.tsx";
import LegalPage from "../landing/LegalPage.tsx";

export default function LegalModal({
    pathname = '',
    onClose = () => {
    }
}) {
    const globalModal = useGlobalModal();

    const onCloseMain = () => {
        globalModal.close();
        onClose()
    }

    return (
        <Modal isOpen={true} placement={"top"}
               scrollBehavior={"inside"}
               isDismissable={false}
               onOpenChange={() => {
                   onCloseMain();
               }}
               classNames={{
                   base: "bg-[#0A1547]",
               }}
        >
            <ModalContent>
                <ModalHeader className={"text-white"}>
                    {pathname === '/terms/' && 'Terms & Conditions'}
                    {pathname === '/privacy/' && 'Privacy Policy'}
                    {pathname === '/leaderboard-terms/' && 'League Leaderboard Participation Terms'}
                </ModalHeader>
                <ModalBody style={{
                    scrollbarColor: "red",
                }} className={" overflow-y-auto " +
                    "[&::-webkit-scrollbar]:w-3 " +
                    "[&::-webkit-scrollbar-track]:rounded-full " +
                    "[&::-webkit-scrollbar-track]:bg-[#0A1547] " +
                    "[&::-webkit-scrollbar-thumb]:rounded-full " +
                    "[&::-webkit-scrollbar-thumb]:bg-gray-300 " +
                    "dark:[&::-webkit-scrollbar-track]:bg-neutral-700 " +
                    "dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500"
                }>
                    <LegalPage pathname={pathname} minimal={true} />
                </ModalBody>
                <ModalFooter>
                    <PButton onPress={onCloseMain}>
                        Close
                    </PButton>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
